module.exports = __webpack_public_path__ + "img/platform2.0943c6b.png";